import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiRequest } from "@core/services/api/apiRequest";
import type { ActionStatusType } from "../actions.types";

export type UseUpdateActionStatusArgs = {
  actionId: number;
  status: ActionStatusType;
  onDone?: () => Promise<void>;
};

/**
 * Hook to update the status of an action.
 * Uses the /actions/{actionId}/status/ endpoint.
 */
export function useUpdateActionStatus({
  actionId,
  status,
  onDone,
}: UseUpdateActionStatusArgs) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (overrides?: { status?: ActionStatusType } | void) => {
      const statusToSend =
        (overrides && "status" in overrides ? overrides.status : undefined) ??
        status;
      return await apiRequest(`/actions/${actionId}/status/`, "POST", {
        status: statusToSend,
      });
    },
    onError: (error: Error) => {
      throw error;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ["actions"],
      });

      await onDone?.();
    },
  });
}

